import type {
  AnnotationInputFacebook,
  AnnotationInputLinkedIn,
} from '../../graphqlTypes'
import type { MapperContext } from '../../types'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'
import { EditorStateProxy } from '~publish/legacy/composer/composer/entities/EditorStateProxy'

// Facebook mentions extracted from the editor are already stored in the wire
// shape; still mapped field-by-field so editor-only additions can never leak
// into the mutation input. No mentions → `undefined` (omit).
export function getFacebookAnnotations(
  draft: Draft,
  ctx: Pick<MapperContext, 'editor'>,
): AnnotationInputFacebook[] | undefined {
  const entities = EditorStateProxy.getFacebookAutocompleteEntities(
    ctx.editor ?? draft.editorState,
  )
  if (entities.length === 0) return undefined

  return entities.map((entity) => ({
    content: entity.content,
    text: entity.text,
    url: entity.url,
    indices: entity.indices,
  }))
}

// LinkedIn annotations, mapped field-by-field: the legacy entity `id` is
// `string | number` (numeric for organizations) while the GraphQL input wants
// a `String!`. No annotations → `undefined` (omit).
export function getLinkedInAnnotations(
  draft: Draft,
  ctx: Pick<MapperContext, 'editor'>,
): AnnotationInputLinkedIn[] | undefined {
  const annotations = EditorStateProxy.getAllLinkedinAnnotations(
    ctx.editor ?? draft.editorState,
  )
  if (annotations.length === 0) return undefined

  return annotations.map((annotation) => ({
    id: String(annotation.id),
    link: annotation.link,
    entity: annotation.entity,
    vanityName: annotation.vanityName,
    localizedName: annotation.localizedName,
    start: annotation.start,
    length: annotation.length,
  }))
}
